export default {
  /**
   * 设置用户信息（不传值则清空用户信息）
   */
  setUserInfo(state, info) {
    const userInfo = info || {
      avatar: "",
      nickname: "",
      uuid: "",
      ticket: "",
    };

    state.userInfo = {
      ...state.userInfo,
      ...userInfo,
    };
  },
};
